// extracted by mini-css-extract-plugin
module.exports = {"root":"AppHeader_root__ppYHH","wrapper":"AppHeader_wrapper__hauhF"};